import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/find-car-form.css";
import { Form, FormGroup } from "reactstrap";
import { toast } from "react-toastify";   
import { brandByModel } from "../utils/brandsData";
import { useSelector } from "react-redux";

const FindCarForm = () => {
  const [vehicleBrand, setVehicleBrand] = useState("");
  const productState = useSelector((state) => state?.product?.product);

  const [brandModel, setBrandModel] = useState("");
  const [minYear, setMinYear] = useState("");
  const [maxYear, setMaxYear] = useState("");
  const [selectedEngineSize, setSelectedEngineSize] = useState("");
  const [transmission, setTransmission] = useState("");
  const [selectedBudget, setSelectedBudget] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !vehicleBrand &&
      !brandModel &&
      !minYear &&
      !maxYear &&
      !selectedEngineSize &&
      !transmission &&
      !selectedBudget
    ) {
      toast.error("Please choose at least one filter!");
      return;
    }

    const queryParams = new URLSearchParams({
      vehicle_brand: vehicleBrand,
      brand_model: brandModel,
      year_of_manufacture__gte: minYear,
      year_of_manufacture__lte: maxYear,
      engine_size: selectedEngineSize,
      transmission,
      price__gte: selectedBudget ? selectedBudget[0] : "",
      price__lte: selectedBudget ? selectedBudget[1] : "",
    }).toString();

    navigate(`/search?${queryParams}`);
  };

  const handleBrandChange = (e) => {
    setVehicleBrand(e.target.value);
    setBrandModel("");
  };

  const handleBudgetFilter = (min, max) => {
    setSelectedBudget([min, max]);
  };

  const clearBudgetFilter = () => {
    setSelectedBudget(null);
  };

  // Extract available engine sizes
  const engineSizes = Array.from(
    new Set(
      productState
        ?.flatMap(item => item.engineSize?.map(sizeObj => sizeObj.title) || [])
        .filter(Boolean)
    )
  ).sort((a, b) => parseInt(a) - parseInt(b));

  // Extract available years
  const availableYears = Array.from(
    new Set(
      productState?.map(item => parseInt(item.yom)).filter(Boolean)
    )
  ).sort((a, b) => a - b);
 
  return (
    <Form className="find-car-form" onSubmit={handleSubmit}>
      <div className="form-grid">

        {/* Budget */}
        <div className="filter-card-el mb-3 budget__filter-wrapper">
          <h3 className="filter-title">Filter by Budget</h3>
          <ul className="budget-filter-element">
            <li
              className={selectedBudget?.[0] === 0 && selectedBudget?.[1] === 500000 ? "selected" : ""}
              onClick={() => handleBudgetFilter(0, 500000)}
            >
              0 - 500K
            </li>
            <li
              className={selectedBudget?.[0] === 500000 && selectedBudget?.[1] === 1000000 ? "selected" : ""}
              onClick={() => handleBudgetFilter(500000, 1000000)}
            >
              500K - 1M
            </li>
            <li
              className={selectedBudget?.[0] === 1000000 && selectedBudget?.[1] === 2000000 ? "selected" : ""}
              onClick={() => handleBudgetFilter(1000000, 2000000)}
            >
              1M - 2M
            </li>
            <li
              className={selectedBudget?.[0] === 2000000 && selectedBudget?.[1] === 3000000 ? "selected" : ""}
              onClick={() => handleBudgetFilter(2000000, 3000000)}
            >
              2M - 3M
            </li>
            <li
              className={selectedBudget?.[0] === 3000000 && selectedBudget?.[1] === 5000000 ? "selected" : ""}
              onClick={() => handleBudgetFilter(3000000, 5000000)}
            >
              3M - 5M
            </li>
            <li
              className={selectedBudget?.[0] === 5000000 && selectedBudget?.[1] === 10000000 ? "selected" : ""}
              onClick={() => handleBudgetFilter(5000000, 10000000)}
            >
              5M - 10M
            </li>
            <li
              className={selectedBudget?.[0] === 10000000 && selectedBudget?.[1] === Infinity ? "selected" : ""}
              onClick={() => handleBudgetFilter(10000000, Infinity)}
            >
              Above 10M
            </li>
                      {selectedBudget && (
            <button type="button" className="clear-btn" onClick={clearBudgetFilter}>
              Clear
            </button>
          )}
          </ul>

        </div>

        {/* Brand & Model */}
        <div className="form-section">
          <p className="form-section-title">Brand & Model</p>
          <div className="form-row">
            <FormGroup className="form__group">
              <select
                className="form-select"
                value={vehicleBrand}
                onChange={handleBrandChange}
              >
                <option value="">Vehicle Brand</option>
                {Object.keys(brandByModel).map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
            </FormGroup>
            <FormGroup className="form__group">
              <select
                className="form-select"
                value={brandModel}
                onChange={(e) => setBrandModel(e.target.value)}
                disabled={!vehicleBrand}
              >
                <option value="">Brand Model</option>
                {brandByModel[vehicleBrand]?.map((model, index) => (
                  <option key={index} value={model}>
                    {model}
                  </option>
                ))}
              </select>
            </FormGroup>
          </div>
        </div>

        {/* Year of Manufacture */}
        <div className="form-section">
          <p className="form-section-title">Year of Manufacture</p>
          <div className="form-row">
            <FormGroup className="form__group">
              <select value={minYear} onChange={e => setMinYear(e.target.value)} className="form-select">
                <option value="">Min Year</option>
                {availableYears.map(year => <option key={year} value={year}>{year}</option>)}
              </select>
            </FormGroup>
            <FormGroup className="form__group">
              <select value={maxYear} onChange={e => setMaxYear(e.target.value)} className="form-select">
                <option value="">Max Year</option>
                {availableYears.map(year => <option key={year} value={year}>{year}</option>)}
              </select>
            </FormGroup>
          </div>
        </div>

{/* Engine Size */}
        <div className="form-section">
          <p className="form-section-title">Engine Size (CC)</p>
          <div className="form-row">
            <FormGroup className="form__group">
              <select className="form-select" value={selectedEngineSize} onChange={(e)=>setSelectedEngineSize(e.target.value)}>
                <option value="">Select Engine Size</option>
                {engineSizes.map((size,index)=>(
                  <option key={index} value={size}>{size}</option>
                ))}
              </select>
            </FormGroup>
          </div>
        </div>


        {/* Transmission */}
        <div className="form-section">
          <p className="form-section-title">Transmission</p>
          <FormGroup className="form__group">
            <select
              className="form-select"
              value={transmission}
              onChange={(e) => setTransmission(e.target.value)}
            >
              <option value="">Select Transmission</option>
              <option value="automatic">Automatic</option>
              <option value="manual">Manual</option>
            </select>
          </FormGroup>
        </div>

        {/* Submit */}
        <FormGroup className="form__group full-width">
          <button className="btn find__car-btn">Find Car</button>
        </FormGroup>
      </div>
    </Form>
  );
};

export default FindCarForm;
